export const isObjectFilled = (object, ignoredFields = ["__v"]) => {
  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      let ignoredField = ignoredFields.includes(key);
      if (!ignoredField && (object[key] === "" || object[key] === 0)) {
        console.log("Property empy on object", key, object[key]);
        return false;
      }
    }
  }
  return true;
};

export const addIgnoredField = (arr, field) => {
  if (arr.includes(field)) return arr;
  return [...arr, field];
};

export const removeIgnoredField = (arr, field) => {
  const fieldIndex = arr.indexOf(field);
  if (fieldIndex === -1) return arr;
  const result = [...arr];
  result.splice(fieldIndex, 1);
  return result;
};

export function toTitleCase(str = "") {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
